import { TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { Banner, Stack } from '@optimus-web/core';
import { useGetCurrentUserQuery } from '../../queries/useGetCurrentUsersQuery';
import { AuthenticatorSetting } from './Authenticator/AuthenticatorSetting';
import { CookiesSettings } from './Cookies/CookiesSettings';
import { ChangePasswordSettings } from './Password/ChangePasswordSettings';
import { PinSetting } from './Pin/PinSetting';
import { SecuritySubsection } from './SecuritySubsection';
import { TrustedDeviceList } from './TrustedDeviceList/TrustedDeviceList';
import { Passkeys } from './Passkeys/Passkeys';

const Security = () => {
    const { data: currentUser } = useGetCurrentUserQuery();

    return (
        <Stack vertical spacing="400">
            <SecuritySubsection title={TextKey.LoginNoun}>
                {currentUser?.ssoEnforced && (
                    <Banner
                        variant="warning"
                        primaryText={<LocalizedText textKey={TextKey.SettingsSecuritySsoEnforcedBannerPrimary} />}
                        secondaryText={<LocalizedText textKey={TextKey.SettingsSecuritySsoEnforcedBannerSecondary} />}
                    />
                )}
                <Passkeys />
                <AuthenticatorSetting currentUser={currentUser} />
                <PinSetting />
                <ChangePasswordSettings />
            </SecuritySubsection>

            <TrustedDeviceList />

            <SecuritySubsection title={TextKey.CookiesAndDataTitle}>
                <CookiesSettings />
            </SecuritySubsection>
        </Stack>
    );
};

export default Security;
